
function refreshSliderButtons()
{
    $('.slider-button[aria-disabled="false"]').attr('tabindex', 0);
    $('.slider-button[aria-disabled="true"]').attr('tabindex', -1);
}

var nothingSelectedLabel = "Aucune sélection"
switch (currentLang) {
    case 'en': nothingSelectedLabel = 'Nothing selected'; break;
    case 'de': nothingSelectedLabel = 'Wählen'; break;
}

function checkScroll() {
    var startY = $('.header-top').height(); //The point where the navbar changes in px
    if ($(window).scrollTop() > startY) {
        $('.header').addClass('scrolled');
    } else {
        $('.header').removeClass('scrolled');
    }
}

function siteFade() {
    setTimeout(function () {
        $('body').addClass('render');
    }, 60);

    $('.js-site--fade').on('click', function (e) {
        if ($(this).attr("href").indexOf("mailto:") == -1 && $(this).attr("target") != "_blank") {
            e.preventDefault();
            if ($(this).attr('href') != '#') {
                var url = $(this).attr('href');
                $('body').removeClass('render');
                setTimeout(function () {
                    window.location = url;
                }, 350);
            }
        }
    });

    $('a[href*=\\#]:not(".js-scroll-trigger"):not("#bs-cookies-dismiss"):not("CybotCookiebotDialogBodyButtonDetails"):not("#CybotCookiebotDialogBodyButtonAccept")').on('click', function (e) {
        e.preventDefault();
        if (this.pathname != window.location.pathname) {
            var url = $(this).attr('href');
            $('body').removeClass('render');
            setTimeout(function () {
                window.location = url;
            }, 350);

        }
    });
}

// Scroll to
/* Au clic sur un lien et scroll sur une autre page */
function scrollToAnotherPage() {
    var headerMainHeight = $('.header-main').height();
    var navigationInlineHeight = $('.navigation-inline').height();

    if ($('.navigation-inline').length > 0) {
        var offsetScrollNav = headerMainHeight + navigationInlineHeight + 35;

    } else {
        var offsetScrollNav = headerMainHeight + 35;
    }

    if (window.location.hash) {
        $('html, body').css('opacity', '0');

        setTimeout(function () {
            $('html, body').scrollTop(0).show();
            $('html, body').css('opacity', '1');
            $('html, body').animate({
                scrollTop: ($(window.location.hash).offset().top - offsetScrollNav)
            }, 1200, 'easeInOutExpo')
        }, 700);
    }
}

function linkUrlHub() {
    $('.pagelist-hub .js-hub-link').on('click', function (e) {
        e.preventDefault();
        var url = $(this).data('href');
        $('body').removeClass('render');
        //$('body').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
            window.location = url;
       // });
    });
}

$('document').ready(function () {
    // Width
    var width = window.innerWidth || document.body.clientWidth;

    // Fade in / fade out page transition
   // siteFade();

    if($('.pagelist-hub').length > 0){
        linkUrlHub();
    }

    scrollToAnotherPage();

    // Check touch devices
    var checkMobile = function () {
        var isTouch = ('ontouchstart' in document.documentElement);
        if (isTouch) {
            $('html').addClass('touch');
        } else {
            $('html').addClass('no-touch');
        }
    };
    checkMobile();

    // Tap events zepto
    $('.card-header').on('touchstart', function () {
        $(this).addClass('active-state');
    });
    $('.card-header').on('touchend', function () {
        $(this).removeClass('active-state');
    });

    // Scroll top
    $('.scroll-top').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, 1200, 'easeInOutExpo');
    });

    if ($('.scrollMap').length > 0) {

        var headerMainHeight = $('.header-main').height();
        var navigationInlineHeight = $('.navigation-inline').height();

        if ($('.navigation-inline').length > 0) {
            var offsetScrollNav = headerMainHeight + navigationInlineHeight + 35;
            var offsetScrollNavSticky = headerMainHeight + navigationInlineHeight + 40;

        } else {
            var offsetScrollNav = headerMainHeight + 35;
            var offsetScrollNavSticky = headerMainHeight + 40;
        }
        $('.scrollMap').on('click', function (e) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: (target.offset().top - offsetScrollNav)
                }, 1200, 'easeInOutExpo');
                return false;
            }
        });
    }



    // Mmenu
    if ($('#responsive-menu').length > 0) {
        var $menu = $('#responsive-menu').mmenu({
            navbar: {
                add: true,
                title: 'Menu'
            },
            navbars: [{
                position: 'top'
            }],
            'extensions': [
                'position-right'
            ]
        }, {
            offCanvas: {
                pageSelector: "#main-content"
            }
        });

        var $mmenuIcon = $('.burger-nav-button');
        var $mmenuAPI = $menu.data("mmenu");

        $mmenuIcon.on('click', function () {
            if ($('html').hasClass('mm-wrapper_opened')) {
                $mmenuAPI.close();
            } else {
                $mmenuAPI.open();
            }
        });

        $mmenuAPI.bind('open:start', function () {
            $mmenuIcon.addClass('is-active');
            if (!$('.header').hasClass('scrolled')) {
                $('.header').addClass('is-opening');
            }
        });
        $mmenuAPI.bind('close:start', function () {
            $mmenuIcon.removeClass('is-active');
            if (!$('.header').hasClass('scrolled')) {
                $('.header').removeClass('is-opening');
            }
        });
    }

    /** DISPLAY MESSAGES AS IZITOAST **/
    refreshIziToastMessages();

    // Scrollspy
    var headerMainHeight = $('.header-main').height();
    var navigationInlineHeight = $('.navigation-inline').height();

    if ($('.navigation-inline').length > 0) {
        var offsetScroll = headerMainHeight + navigationInlineHeight + 41;
    } else {
        var offsetScroll = headerMainHeight + 41;
    }

    $('body').scrollspy({
        target: '.js-scroll-anchor',
        offset: offsetScroll
    });

    // Headroom
    if ($('.header').length > 0) {
        if (width >= 992) {
            var navbar = document.querySelector('header');
            new Headroom(navbar, {
                'offset': 50,
                'tolerance': -5,
                'classes': {
                    initial: "slide",
                    pinned: "slide--pinned",
                    unpinned: "slide--unpinned",
                    top: "slide--top",
                    notTop: "slide--not-top",
                    bottom: "slide--bottom",
                    notBottom: "slide--not-bottom"
                }
            }).init();
        }
    }

    $(window).on('scroll load resize', function () {
        if (width < 992) {
            checkScroll();
        }
    });

    /* Hover dropdown-menu
 --------------------------------------------------------------------------------------------------------------------- */

    /** ACCESSIBILITY DROPDOWN **/

    $('.header-main li.nav-item.dropdown button.toggle-submenu, .navbar-top li.nav-item.dropdown button.toggle-submenu, .header-main li.nav-item.dropdown .dropdown-toggle, .navbar-top li.nav-item.dropdown .dropdown-toggle').click(function (e) {
        var eventListenerAccessNav = !$(this).hasClass('dropdown-toggle') ? 'button.toggle-submenu' : '.dropdown-toggle';
        e.preventDefault();

        var liParent = $(this).parent().parent();
        var aParent = eventListenerAccessNav == '.dropdown-toggle' ? $(this) : $(this).parent();

        if ($(liParent).hasClass("show")) {
            $(liParent).removeClass("show");
            $(liParent).children('.dropdown-menu').removeClass('show');
            $(aParent).attr('aria-expanded', "false");
            $(this).attr('aria-expanded', "false");
        } else {
            $(liParent).addClass("show");
            $(liParent).children('.dropdown-menu').addClass('show');
            $(aParent).attr('aria-expanded', "true");
            $(this).attr('aria-expanded', "true");
        }

        return false;
    });

    if ($('html').hasClass('no-touch')) {
        $('.header .nav-item.dropdown').hover(
          function () {
              if(!$(this).hasClass('language-wrapper-resp')) {
                  $(this).addClass('show');
                  $(this).children('.dropdown-menu').addClass('show');
                  siteFade();
              }
          },
          function () {
              if(!$(this).hasClass('language-wrapper-resp')) {
                  $(this).removeClass('show');
                  $(this).children('.dropdown-menu').removeClass('show');
              }
          }
        );
        $('.header .nav-item.dropdown').click(function (e) {
            if(!$(this).hasClass('language-wrapper-resp')) {
                e.stopPropagation();
            } else {
                e.preventDefault();
            }
        })
    }

    if ($('html').hasClass('no-touch')) {
        $('.header .nav-item.dropdown-submenu').hover(
            function () {
                $(this).parent('.dropdown-menu').addClass('remove-radius')
                $(this).addClass('show active-for-level3');
                $(this).children('.dropdown-menu').addClass('show');
                siteFade();
            },
            function () {
                $(this).parent('.dropdown-menu').removeClass('remove-radius')
                $(this).removeClass('show active-for-level3');
                $(this).children('.dropdown-menu').removeClass('show');
            }
        );
        $('.header .nav-item.dropdown-submenu').click(function (e) {
            e.stopPropagation();
        })
    }

    // Collect image hover
    if ($('html').hasClass('touch')) {
        $('.collect form input[name=accept-conditions-1]').on('change', function () {
            if ($(this).is(':checked')) {
                $('.collect .collect-message-wrapper-1').addClass('has-checked');
            } else {
                $('.collect .collect-message-wrapper-1').removeClass('has-checked');
            }
        });
        $('.collect form input[name=accept-conditions-2]').on('change', function () {
            if ($(this).is(':checked')) {
                $('.collect .collect-message-wrapper-2').addClass('has-checked');
            } else {
                $('.collect .collect-message-wrapper-2').removeClass('has-checked');
            }
        });
        $('.collect form input[name=accept-conditions-3]').on('change', function () {
            if ($(this).is(':checked')) {
                $('.collect .collect-message-wrapper-3').addClass('has-checked');
            } else {
                $('.collect .collect-message-wrapper-3').removeClass('has-checked');
            }
        });
    }

    $('body').on('change', '#selectCommune', function (e) {
        $('*[data-id="selectCommune"]').addClass('loading');

        var selectedOption = $( "#selectCommune option:selected" ).text();
        // console.log(dataLayer);
        dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'selectionMade',
            selectedElement: selectedOption
        });

        if ($(this).val() == "nosidec") {
            $('*[data-commune="sidec"]').addClass('d-none');
            $('*[data-commune="sacvert"]').addClass('d-none');
            $('*[data-commune="nosidec"]').addClass('d-none');
        } else if ($(this).val() == "sacvert") {
            $('*[data-commune="sidec"]').addClass('d-none');
            $('*[data-commune="nosidec"]').removeClass('d-none');
            $('*[data-commune="sacvert"]').removeClass('d-none');
        } else {
            $('*[data-commune="sidec"]').removeClass('d-none');
            $('*[data-commune="sacvert"]').removeClass('d-none');
            $('*[data-commune="nosidec"]').removeClass('d-none');
        }
        setTimeout(function () {
            $('*[data-id="selectCommune"]').removeClass('loading');
        }, 1000);
    })
});

// Validation form BS4
(function () {
    'use strict';
    window.addEventListener('load', function () {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();
